import { t } from '@lingui/core/macro';
import { PackageFamily } from '@luminovo/api-contracts';
import { FieldMultiSelect, FieldMultiSelectProps } from '@luminovo/design-system';

import { formatPackage } from '../../../formatters';

export function FieldPackageFamily(
    props: Omit<FieldMultiSelectProps<PackageFamily>, 'getOptionKey' | 'getOptionLabel'>,
): JSX.Element {
    return (
        <FieldMultiSelect
            getOptionKey={(pkg) => {
                return `${pkg.name}::${pkg.mounting}`;
            }}
            virtualized
            disableCloseOnSelect
            getOptionLabel={(pkg) => {
                return formatPackage(pkg);
            }}
            error={props.value?.length === 0}
            helperText={props.value?.length === 0 ? t`Required` : undefined}
            placeholder={t`Package family`}
            limitTags={10}
            {...props}
        />
    );
}
